import { useEffect } from 'react';

const SITE_URL = 'https://vijayindustry.co.in';
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.png`;

export default function SEO({
  title = "Vijay Industry | Pre-Engineered Buildings & Industrial Steel Structures",
  description = "Vijay Industry is a premier manufacturer and fabricator of pre-engineered steel buildings, factory sheds, warehouses, mezzanine floors, and structural MS/SS solutions in Coimbatore, Tamil Nadu.",
  keywords = "Pre-Engineered Buildings Coimbatore, PEB Structure Manufacturers Tamil Nadu, Factory Shed Contractors, Industrial Steel Warehouse Construction, Mezzanine Floor Fabricators, Roofing Sheet Installation Coimbatore, MS Steel Works, SS Railings",
  canonical = "/",
  robots = "index, follow",
  ogTitle,
  ogDescription,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
  schemaData = null
}) {
  useEffect(() => {
    // 1. Update Title
    document.title = title;

    // Helper to update or create meta tags
    const updateMetaTag = (selectorAttr, selectorValue, contentValue) => {
      let element = document.querySelector(`meta[${selectorAttr}="${selectorValue}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(selectorAttr, selectorValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', contentValue);
    };

    // Helper to update or create link tags
    const updateLinkTag = (rel, href) => {
      let element = document.querySelector(`link[rel="${rel}"]`);
      if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
      }
      element.setAttribute('href', href);
    };

    const fullCanonicalUrl = canonical.startsWith('http') ? canonical : `${SITE_URL}${canonical}`;
    const fullOgImage = ogImage.startsWith('http') ? ogImage : `${SITE_URL}${ogImage}`;

    // 2. Standard Meta Tags
    updateMetaTag('name', 'description', description);
    updateMetaTag('name', 'keywords', keywords);
    updateMetaTag('name', 'robots', robots);
    updateLinkTag('canonical', fullCanonicalUrl);

    // 3. Open Graph Tags
    updateMetaTag('property', 'og:title', ogTitle || title);
    updateMetaTag('property', 'og:description', ogDescription || description);
    updateMetaTag('property', 'og:image', fullOgImage);
    updateMetaTag('property', 'og:url', fullCanonicalUrl);
    updateMetaTag('property', 'og:type', ogType);
    updateMetaTag('property', 'og:site_name', 'Vijay Industry');

    // 4. Twitter Card Tags
    updateMetaTag('name', 'twitter:card', 'summary_large_image');
    updateMetaTag('name', 'twitter:title', ogTitle || title);
    updateMetaTag('name', 'twitter:description', ogDescription || description);
    updateMetaTag('name', 'twitter:image', fullOgImage);

    // 5. JSON-LD Structured Data Injection
    const scriptId = 'json-ld-schema';
    let scriptTag = document.getElementById(scriptId);

    if (schemaData) {
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.id = scriptId;
        scriptTag.type = 'application/ld+json';
        document.head.appendChild(scriptTag);
      }
      scriptTag.text = JSON.stringify(schemaData);
    } else if (scriptTag) {
      scriptTag.remove();
    }
  }, [title, description, keywords, canonical, robots, ogTitle, ogDescription, ogImage, ogType, schemaData]);

  return null;
}
